import { QuotationState } from '@savgroup-front-common/types';

import globalMessages from '../helpers/i18n';

export const formatQuotationState = (state: QuotationState) => {
  if (!state) {
    return '';
  }

  switch (state.toLowerCase()) {
    case QuotationState.CANCELLED.toLowerCase():
      return globalMessages.quotationStateMessages.cancelled;
    case QuotationState.APPROVED.toLowerCase():
      return globalMessages.quotationStateMessages.approved;
    case QuotationState.REJECTED.toLowerCase():
      return globalMessages.quotationStateMessages.rejected;
    case QuotationState.DRAFT.toLowerCase():
      return globalMessages.quotationStateMessages.draft;
    case QuotationState.PAID.toLowerCase():
      return globalMessages.quotationStateMessages.paid;
    case QuotationState.PENDING_CUSTOMER_APPROVAL.toLowerCase():
    case QuotationState.PENDING_CUSTOMER_VALIDATION.toLowerCase():
      return globalMessages.quotationStateMessages.pendingCustomerApproval;
    case QuotationState.END_OF_MONTH_CONSOLIDATED_PAYMENT.toLowerCase():
      return globalMessages.quotationStateMessages
        .endOfMonthConsolidatedPayment;
    default:
      throw new Error(`Unknown quotation state: ${state}`);
  }
};
